<template>
  <div class="container mt-5">
    <h1>MANUTENÇÃO - ENTRADA</h1>
    <router-link
      :to="`/checklist/Layout/form/fill/${$store.getters.formVehicleRevisionEntryId}`"
    >
      <b-button size="sm">
        {{ $t("geral.create") }}
      </b-button>
    </router-link>
    <b-button size="sm" style="margin-left: 10px" @click="clearFilters">
      Limpar Filtros
    </b-button>
    <router-link :to="`/checklist/revision/entryConfiguration`">
      <b-button v-if="userRms" size="sm" class="ml-2"
        >Configurador</b-button
      ></router-link
    >

    <b-table
      :items="maintenanceEntries"
      :fields="fields"
      responsive
      class="mt-4"
      table-class="w-100"
      table-style="table-layout: fixed;"
      :filter="tableFilters"
      :filter-debounce="500"
      :filter-function="filterFunction"
    >
      <template slot="thead-top" slot-scope="{ fields }">
        <b-tr>
          <b-th v-for="field in fields" :key="field.key" class="vertical-align">
            <div v-if="field.key !== 'actions'">
              <template v-if="field.key === 'revisionType'">
                <b-form-select
                  v-model="tableFilters.revisionType"
                  :options="revisionTypeOptionsWithPlaceholder"
                ></b-form-select>
              </template>
              <template v-else-if="field.key === 'reviewDate'">
                <b-form-input
                  v-model="tableFilters.reviewDate"
                  placeholder="Buscar Data da Manutenção"
                  type="date"
                ></b-form-input>
              </template>
              <template v-else>
                <b-form-input
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar ' + field.label"
                ></b-form-input>
              </template>
            </div>
          </b-th>
        </b-tr>
      </template>

      <!-- <template #cell(actions)="data">
        <router-link
          :to="`/checklist/Layout/form/Fill/${$store.getters.formVehicleRevisionExitId}/${data.item.id}`"
        >
          <i class="tim-icons icon-paper"></i>
        </router-link>
      </template> -->

      <template #cell(reviewDate)="data">
        {{ formatDate(data.item.reviewDate) }}
      </template>

      <template v-slot:cell(originChecklistId)="data">
        <router-link
          :to="'/checklist/form/filled/details/' + data.item.originChecklistId"
        >
          <p>
            <u>
              {{ data.value }}
            </u>
          </p>
        </router-link>
      </template>

      <template v-slot:cell(revisionType)="data">
        {{ getRevisionTypeLabel(data.item.revisionType) }}
      </template>

      <template v-slot:cell(revisionPlace)="data">
        {{ getRevisionPlaceLabel(data.item.revisionPlace) }}
      </template>
    </b-table>
  </div>
</template>

<script>
import RevisionEntryCreate from "../../../../components_rms/vehicle/Revision/RevisionEntryCreate.vue";

export default {
  components: {
    RevisionEntryCreate,
  },
  data() {
    return {
      openModal: false,
      maintenanceEntries: [],
      isEditMode: false,
      currentEntry: {
        id: "",
        driverName: "",
        vehicleId: "",
        companyId: "",
        plate: "",
        reviewDate: "",
        km: "",
        revisionPlace: "",
        description: "",
      },
      tableFilters: {
        originChecklistId: "",
        description: "",
        plate: "",
        revisionType: "",
        reviewDate: "",
        driverName: "",
        revisionPlace: "",
      },
      revisionTypeOptions: [
        { value: "0", text: "Preventiva" },
        { value: "1", text: "Corretiva" },
        { value: "2", text: "Sinistro" },
      ],
      revisionTypeOptionsWithPlaceholder: [
        { value: "", text: "Buscar Tipo de Manutenção" },
        { value: "0", text: "Preventiva" },
        { value: "1", text: "Corretiva" },
        { value: "2", text: "Sinistro" },
      ],
      fields: [
        {
          key: "actions",
          label: "",
          thStyle: "width:8.33%",
          tdStyle: "width:8.33%",
        },
        {
          key: "originChecklistId",
          label: "Id",
          thStyle: "width:8.33%",
          tdStyle: "width:8.33%",
        },
        {
          key: "description",
          label: "Descrição",
          thStyle: "width:16.66%",
          tdStyle: "width:16.66%",
        },
        {
          key: "plate",
          label: "Placa",
          thStyle: "width:8.33%",
          tdStyle: "width:8.33%",
        },
        {
          key: "revisionType",
          label: "Tipo de Manutenção",
          thStyle: "width:16.66%",
          tdStyle: "width:16.66%",
        },
        {
          key: "reviewDate",
          label: "Data da Manutenção",
          thStyle: "width:16.66%",
          tdStyle: "width:16.66%",
        },
        {
          key: "driverName",
          label: "Nome do Motorista",
          thStyle: "width:16.66%",
          tdStyle: "width:16.66%",
        },
        {
          key: "revisionPlace",
          label: "Local da Manutenção",
          thStyle: "width:16.66%",
          tdStyle: "width:16.66%",
        },
      ],
      userRms: false,
    };
  },
  mounted() {
    this.fetchEntries();
    this.isRmsUser();
  },
  computed: {
    hasExitFilled: {
      get: function (value) {
        console.log(value);
        return false;
      },
      set: function (value) {
        console.log(value);
        return this.hasExitFill(value);
      },
      // return this.hasExitFill(checklistId);
    },
  },
  methods: {
    hasExitFill(checklistId, ) {
      let hasExit = false;
      this.$apiVehicle
        .request({
          url: `/vehicle/hasexitfill/${checklistId}`,
          method: "GET",
        })
        .then((response) => {
          console.log(response.data);
          hasExit = response.data;
          return hasExit;
        });
        
    },
    async isRmsUser() {
      this.$apiScheduler.get("/user/isRms").then((response) => {
        this.userRms = response.data;
      });
    },
    openCreateModal() {
      this.isEditMode = false;
      this.currentEntry = {
        id: 0,
        companyId: 0,
        revisionType: "",
        driverName: "",
        vehicleId: "",
        plate: "",
        reviewDate: "",
        km: "",
        revisionPlace: "",
        description: "",
      };
      this.openModal = true;
    },
    openEditModal(entry) {
      this.isEditMode = true;
      this.currentEntry = {
        ...entry,
        revisionPlace: entry.revisionPlace.toString(),
        revisionType: entry.revisionType.toString(),
      };
      if (this.currentEntry.reviewDate) {
        this.currentEntry.reviewDate = this.formatDateForInput(
          this.currentEntry.reviewDate
        );
      }
      this.openModal = true;
    },
    closeModal() {
      this.openModal = false;
    },
    async fetchEntries() {
      try {
        const response = await this.$apiVehicle.get("/GetAllRevisionsEntry/");
        this.maintenanceEntries = response.data;
      } catch (error) {
        console.error("Erro ao buscar entradas de manutenção:", error);
      }
    },
    handleSuccess() {
      this.openModal = false;
      this.fetchEntries();
    },
    onModalHide() {
      this.isEditMode = false;
      this.currentEntry = {
        id: 0,
        driverName: "",
        revisionType: "",
        vehicleId: "",
        companyId: "",
        plate: "",
        reviewDate: "",
        km: "",
        revisionPlace: "",
        description: "",
      };
    },
    formatDate(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    formatDateForInput(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
    focusFirstInput() {
      this.$nextTick(() => {
        const firstInput = this.$el.querySelector("input");
        if (firstInput) firstInput.focus();
      });
    },
    getRevisionTypeLabel(revisionType) {
      switch (revisionType.toString()) {
        case "0":
          return "Preventiva";
        case "1":
          return "Corretiva";
        case "2":
          return "Sinistro";
        default:
          return "Desconhecido";
      }
    },
    getRevisionPlaceLabel(revisionPlace) {
      switch (revisionPlace.toString()) {
        case "0":
          return "Interna";
        case "1":
          return "Externa";

        default:
          return "Desconhecido";
      }
    },
    clearFilters() {
      this.tableFilters = {
        originChecklistId: "",
        description: "",
        plate: "",
        revisionType: "",
        reviewDate: "",
        driverName: "",
        revisionPlace: "",
      };
    },
    filterFunction(item, filter) {
      if (
        filter.originChecklistId &&
        !item.originChecklistId.toString().includes(filter.originChecklistId)
      ) {
        return false;
      }
      if (
        filter.description &&
        !item.description
          .toLowerCase()
          .includes(filter.description.toLowerCase())
      ) {
        return false;
      }
      if (
        filter.plate &&
        !item.plate.toLowerCase().includes(filter.plate.toLowerCase())
      ) {
        return false;
      }
      if (
        filter.revisionType &&
        item.revisionType.toString() !== filter.revisionType
      ) {
        return false;
      }
      if (
        filter.reviewDate &&
        this.formatDateForInput(item.reviewDate) !== filter.reviewDate
      ) {
        return false;
      }
      if (
        filter.driverName &&
        !item.driverName.toLowerCase().includes(filter.driverName.toLowerCase())
      ) {
        return false;
      }
      if (
        filter.revisionPlace &&
        !item.revisionPlace
          .toLowerCase()
          .includes(filter.revisionPlace.toLowerCase())
      ) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
.table th,
.table td {
  text-align: center;
}
.form-group {
  margin-bottom: 15px;
}
.vertical-align {
  vertical-align: middle !important;
}
</style>
